// @flow

import type { Node } from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../types';
import { getBackgroundColor } from '../../helpers';
import type { RowColor } from '../../types/acf/row';
import type { ACFBoxedVariant } from '../../types/acf/column';
import { getGradient } from './helpers';

type Props = {|
  backgroundColor?: RowColor,
  variant?: ACFBoxedVariant,
  spread?: boolean,
  children?: Node,
|};

const getBorder = (variant: string = 'shadow', theme: Theme) => {
  switch (variant) {
    case 'shadow':
      return css`
        box-shadow: ${theme.card.boxShadow};
        margin-bottom: 0.25rem;
      `;
    case 'line':
      return css`border: 1px solid ${theme.card.borderColor};`;
    default:
      return '';
  }
};

const Card = styled<any, Theme, Props>('section')`
  ${props => props.backgroundColor && getBackgroundColor(props.backgroundColor, props.theme, props.theme.card.backgroundColor)}

  ${props => {
    if (!props.backgroundColor) {
      return null;
    }
    const gradient = getGradient(props.theme.card.gradient, props.backgroundColor);
    if (!gradient) {
      return null;
    }
    return css`background-image: ${gradient.main}`;
  }};

  ${props => getBorder(props.variant, props.theme)}
  border-radius: ${props => props.theme.card.borderRadius};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.card.padding};
  position: relative;
  ${props => props.spread && css`
    justify-content: space-between;
    height: 100%;
  `}

  > * {
    width: 100%;
    margin-bottom: ${props => props.theme.column.padding};
  }

  > *:last-child {
    margin-bottom: 0;
  }

`;

export default Card;
